import React, { useState } from 'react';
import { Wand2, CheckCircle, ArrowRight } from 'lucide-react';
import ContactModal from './ContactModal';
import LoginModal from './LoginModal';
import Layout from './Layout';

const HeroSection: React.FC = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  const handleLoginSuccess = () => {
    setIsLoginModalOpen(false);
  };

  return (
    <section className="bg-gradient-to-br from-indigo-50 to-blue-100">
      <Layout>
        <div className="min-h-[50vh] md:min-h-[85vh] flex items-center py-20">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
            <div className="md:col-span-6">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 leading-tight">
                L'outil qui transforme votre{' '}
                <span className="gradient-text">marque employeur</span>{' '}
                en com RH en un clic
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Notre outil alimenté par l'IA vous aide à créer des offres d'emploi attrayantes qui attirent les meilleurs talents, sans effort et en un temps record.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start">
                  <CheckCircle className="w-6 h-6 text-green-500 mr-3 mt-0.5" />
                  <p className="text-gray-700">Offres d'emploi optimisées pour LinkedIn et autres plateformes</p>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="w-6 h-6 text-green-500 mr-3 mt-0.5" />
                  <p className="text-gray-700">Personnalisation selon votre entreprise et vos valeurs</p>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="w-6 h-6 text-green-500 mr-3 mt-0.5" />
                  <p className="text-gray-700">Plusieurs styles d'écriture adaptés à votre secteur</p>
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
                <button 
                  onClick={() => setIsLoginModalOpen(true)}
                  className="btn-primary flex items-center justify-center"
                >
                  <Wand2 className="w-5 h-5 mr-2" />
                  <span>Essai gratuit</span>
                </button>
                <button 
                  onClick={() => setIsContactModalOpen(true)}
                  className="btn-secondary flex items-center justify-center"
                >
                  <span>En savoir plus</span>
                  <ArrowRight className="w-5 h-5 ml-2" />
                </button>
              </div>
            </div>
            
            <div className="md:col-span-6">
              <div className="bg-white p-6 rounded-lg shadow-xl">
                <div className="bg-indigo-50 p-4 rounded-lg mb-4">
                  <h3 className="text-lg font-semibold text-indigo-800 mb-2">Exemple d'offre générée</h3>
                  <div className="prose prose-sm max-w-none">
                    <p>🚀 <strong>Rejoignez notre équipe en tant que Développeur Full-Stack !</strong></p>
                    <p>Vous aussi vous croyez à l'innovation, l'excellence et la collaboration ? Alors venez partager le quotidien de nos équipes !</p>
                    <p>Chez TechInnovate, nous créons des solutions digitales qui transforment le quotidien de nos clients. En tant que Développeur Full-Stack, vous participerez à la conception et au développement de nos applications web et mobiles, en travaillant avec les dernières technologies.</p>
                    <p>Nous recherchons un profil avec :</p>
                    <ul>
                      <li>3+ ans d'expérience en développement web</li>
                      <li>Maîtrise de React, Node.js et des bases de données SQL/NoSQL</li>
                      <li>Esprit d'équipe et capacité à résoudre des problèmes complexes</li>
                    </ul>
                    <p>Nous offrons :</p>
                    <ul>
                      <li>Un environnement de travail stimulant</li>
                      <li>Des projets variés et innovants</li>
                      <li>Une rémunération compétitive</li>
                      <li>Des possibilités d'évolution</li>
                    </ul>
                    <p>Intéressé(e) ? Postulez maintenant via notre site web !</p>
                    <p>#Développement #FullStack #Tech #Recrutement #Innovation</p>
                  </div>
                </div>
                <div className="flex justify-end">
                  <button 
                    onClick={() => setIsLoginModalOpen(true)}
                    className="text-primary hover:text-secondary text-sm font-medium flex items-center"
                  >
                    <span>Générer votre offre</span>
                    <ArrowRight className="w-4 h-4 ml-1" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>

      <ContactModal 
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />

      <LoginModal
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
        onLoginSuccess={handleLoginSuccess}
      />
    </section>
  );
};

export default HeroSection;